import { Action } from '@ngrx/store';

export enum ESelectedMsidnActions {
  SetSelectedPhoneNumber = '[MSISDN] Set selected phone number',
}

export class SetSelectedPhoneNumber implements Action {
  public readonly type = ESelectedMsidnActions.SetSelectedPhoneNumber;
  constructor(public payload?: string) {}
}

export type SelectedMsidnActions = SetSelectedPhoneNumber;
